module.exports = __webpack_public_path__ + "img/hdyy_details_2.c52bef04.png";